module.exports = __webpack_public_path__ + "static/media/filter.60832ac9.svg";